import { observable } from 'mobx';
import Helpers from '../../helpers/Helpers';
import { ExplanationModel } from '../../interfaces/models/CardModel';
import { AnswerModel, AnswersAdapter, ExerciseType } from './AnswersAdapter';

export class ExplanationAdapter implements AnswersAdapter {

    totalPlaceholders;
    contentParts;
    type = ExerciseType.explanation;

    @observable answers: AnswerModel[];

    constructor(
        public field: ExplanationModel
    ) {
        this.answers = Helpers.shuffle(
            this.field.solutions
                .map((answer, index) => ({ answer, index }))
        );

        this.totalPlaceholders = this.answers.length;

        this.contentParts = this.field.content
            .split(/\[solution[0-9]+]/)
            .filter(value => value.length);
    }

    verifyAnswer(index, currentPlaceholderIndex) {
        return index === currentPlaceholderIndex;
    }

}
